import { nextjsPlugin } from '@datadog/browser-rum-nextjs';
import { initDatadog } from '@vaad1st/datadog-config';
import { createDatadogBrowserConfig } from './src/utils/services/datadog-browser-config';

export { onRouterTransitionStart } from '@datadog/browser-rum-nextjs';

initDatadog(
  createDatadogBrowserConfig(
    {
      NEXT_PUBLIC_AEM_MODE: process.env.NEXT_PUBLIC_AEM_MODE,
      NEXT_PUBLIC_DATADOG_APPLICATION_ID:
        process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
      NEXT_PUBLIC_DATADOG_CLIENT_TOKEN:
        process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
      NEXT_PUBLIC_DATADOG_ENABLED: process.env.NEXT_PUBLIC_DATADOG_ENABLED,
      NEXT_PUBLIC_DATADOG_SITE: process.env.NEXT_PUBLIC_DATADOG_SITE,
      NEXT_PUBLIC_DATADOG_VERSION: process.env.NEXT_PUBLIC_DATADOG_VERSION,
      NEXT_PUBLIC_ENVIRONMENT_NAME: process.env.NEXT_PUBLIC_ENVIRONMENT_NAME,
    },
    [nextjsPlugin()],
  ),
);
